<template>
  <div class="step-four-page" v-slideIn>
    <Steps :current="4" />
    <div class="content-area" v-loading="loading">
      <h3 class="title">已申请开通服务,请等待后台审核</h3>
      <div class="platform-list">
        <div
          class="platform-card"
          v-for="platform in platformList"
          :key="platform.platformCode"
          @click="goToPlatform(platform)"
        >
          <div class="cover">
            <img :src="platform.platformImageUrl" alt />
            <div>
              <p class="platform-name">{{ platform.platformName }}</p>
              <p class="platform-code">{{ platform.platformAbbreviation }}</p>
            </div>
          </div>
          <div class="foot-button">
            <Button text="前往服务平台" type="danger" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Steps from '@/components/Steps/index.vue';
import Button from '@/components/Button/index.vue';
import api from '@/api';
import { openningAndOpenedStatus, platformCode } from '@/config';

export default {
  name: 'c-step-four',
  data() {
    return {
      openedPlatformList: [],
      loading: true,
      token: localStorage.getItem('sso_biz_token'),
    };
  },
  methods: {
    getPlatformList() {
      return api
        .getServiceInfo({
          token: this.token,
        })
        .then((res) => {
          if (res.code === 0) {
            this.openedPlatformList = res.data;
          }
        });
    },
    go(path) {
      window.open(path);
    },
    goToPlatform(platform) {
      console.log('platform', platform);
      let code = platform.platformCode;

      let self = this;
      let domain = '.zlgx.com';
      let url;
      let prefix;
      let hostname = location.hostname;
      switch (true) {
        case hostname.indexOf('dev') !== -1:
          domain = '.dev.zlgx.com';
          break;
        case hostname.indexOf('test') !== -1:
          domain = '.test.zlgx.com';
          break;
        case hostname.indexOf('localhost') !== -1:
          domain = '.test.zlgx.com';
          break;
        default:
          domain = '.zlgx.com';
      }
      switch (code) {
        case platformCode.trade:
          prefix = 'trade';
          break;
        case platformCode.logistics:
          prefix = 'log';
          break;
        case platformCode.fin:
          prefix = 'fin';
          break;
        case platformCode.wms:
          prefix = 'wms';
          break;
        // 暂时屏蔽集采，招采使用集采的逻辑
        case platformCode.cenpur:
        // domain === '.zlgx.com' ? prefix = 'ore' : prefix = 'jc'
        // break
        case platformCode.bid:
          prefix = 'bid';
          break;
        case platformCode.oa:
          prefix = 'oa';
          break;
        case platformCode.eq:
          prefix = 'eq';
          break;
        default:
          prefix = 'www';
          break;
      }
      url = prefix + domain;
      self.go('//' + url);
    },
    async init() {
      this.loading = true;
      await this.getPlatformList();
      this.loading = false;
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    platformList() {
      return this.openedPlatformList.filter((platform) => {
        // return true;
        // 暂时不屏蔽
        return (
          platform.enable &&
          platform.identity.some((el) => {
            return openningAndOpenedStatus.includes(el.status);
          })
        );
      });
    },
  },
  components: { Steps, Button },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
